// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"LinksBundle__Wrapper_2k-wz"};